'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateProperty = undefined;

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _upgradeDataStates = require('ui-addon-upgrades/_core/common/data/upgradeData/upgradeDataStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateProperty = exports.validateProperty = function validateProperty(isValid, message, propName) {
  if (!isValid) {
    _devLogger2.default.warn({
      message: 'createUpgradeData: ' + message,
      key: 'createUpgradeData: ' + propName
    });

    return _upgradeDataStates.UPGRADE_DATA_INVALID;
  }

  return _upgradeDataStates.UPGRADE_DATA_VALID;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/validators/validateProperty.js
// module id = 155
// module chunks = 3 4 5